import PropTypes from 'prop-types';

import css from './index.module.scss';

/* eslint-disable react/no-array-index-key */
const AlertMessage = ({ links, title, subtitle }) => (
  <>
    <h2 className={css.title}>{title}</h2>
    <p className={css.subtitle} dangerouslySetInnerHTML={{ __html: subtitle }} />
    <ul className={css.links}>
      {links.map((link, idx) => (
        <li className={css.link} key={`link-${title}_${idx}`}>
          {link}
        </li>
      ))}
    </ul>
  </>
);

AlertMessage.propTypes = {
  links: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  subtitle: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default AlertMessage;
